<template>
	<div class="relative">
		<div
			class="bg-gradient-to-b py-44"
			:class="backgroundColorClasses"
		>
			<div
				class="container text-white"
				:class="containerClasses"
				data-testid="background-section-container"
			>
				<slot />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
const {
	width = 'lg',
	color = 'gray',
} = defineProps<{
	width?: 'sm' | 'md' | 'lg';
	color?: 'gray' | 'purple' | 'pink';
}>();

const backgroundColorClasses = computed(() => {
	const classes = [];

	switch (color) {
		case 'gray':
			classes.push('from-gray-900', 'to-gray-700');
			break;
		case 'purple':
			classes.push('from-purple-900', 'to-purple-700');
			break;
		case 'pink':
			classes.push('from-purple-600', 'to-red-200');
			break;
	}

	return classes;
});

const containerClasses = computed(() => {
	const classes = [];

	switch (width) {
		case 'sm':
			classes.push('max-w-screen-sm');
			break;
		case 'md':
			classes.push('max-w-screen-md');
			break;
		case 'lg':
			classes.push('max-w-screen-lg');
			break;
	}

	return classes;
});
</script>
